import { Seo } from "@/lib/seo";
import { PageHero } from "@/components/page-hero";
import { Reveal } from "@/lib/motion";

const SECCIONES: { titulo: string; parrafos: string[] }[] = [
  {
    titulo: "Objeto",
    parrafos: [
      "Estos términos regulan el uso del sitio público de Tulevik Legal. Al usarlo, aceptas estas condiciones; si no estás de acuerdo, por favor no uses el sitio.",
    ],
  },
  {
    titulo: "Contenido informativo, no asesoría jurídica",
    parrafos: [
      "Las páginas de este sitio —incluidas las descripciones de servicios, los momentos de vida y las guías editoriales— tienen fines informativos y de orientación general. No constituyen asesoría jurídica, opinión legal ni contrato de prestación de servicios profesionales.",
      "La asesoría jurídica solo existe dentro de una relación profesional formalizada con el Despacho, con alcance y costos acordados por escrito.",
    ],
  },
  {
    titulo: "Sobre el orientador",
    parrafos: [
      "La herramienta “Encuentra tu ruta” es un mecanismo de clasificación informativa: sugiere un área, temas y documentos posibles a partir de tus respuestas. No realiza diagnóstico legal, no evalúa riesgo y no guarda tus respuestas. Su resultado no obliga al Despacho ni crea una relación profesional.",
    ],
  },
  {
    titulo: "Formulario de contacto y atención prioritaria",
    parrafos: [
      "Enviar un formulario genera una solicitud de contacto, no una aceptación de representación. El Despacho revisa cada solicitud y confirma si puede atender el asunto. La ruta de atención prioritaria agiliza la revisión, pero no garantiza disponibilidad inmediata ni sustituye el cumplimiento de tus propios plazos legales.",
    ],
  },
  {
    titulo: "Propiedad intelectual",
    parrafos: [
      "Los textos, la marca y la identidad visual de este sitio pertenecen a Tulevik Legal. Puedes citar fragmentos breves con atribución y enlace; no puedes reproducir el contenido de forma sustancial sin autorización.",
    ],
  },
  {
    titulo: "Responsabilidad",
    parrafos: [
      "El Despacho no responde por decisiones tomadas con base únicamente en el contenido informativo del sitio. Tampoco por la disponibilidad continua del servicio: realizamos mantenimiento y el sitio puede no estar disponible de forma temporal.",
    ],
  },
  {
    titulo: "Ley aplicable y jurisdicción",
    parrafos: [
      "Estos términos se rigen por las leyes de los Estados Unidos Mexicanos. Para cualquier controversia, las partes se someten a los tribunales competentes de la Ciudad de México o del Estado de México, según corresponda.",
    ],
  },
];

export default function Terminos() {
  return (
    <>
      <Seo
        title="Términos de uso"
        description="Términos de uso del sitio de Tulevik Legal: contenido informativo, orientador, formularios, propiedad intelectual y responsabilidad."
        path="/terminos-de-uso"
      />
      <PageHero
        eyebrow="Legal"
        titulo="Términos de uso"
        lead="Reglas sencillas para usar este sitio con claridad sobre qué es y qué no es Tulevik Legal."
      />
      <section className="bg-parchment">
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-8 sm:py-20">
          {SECCIONES.map((s, i) => (
            <Reveal key={i} y={16}>
              <section className="mb-12" data-testid={`terminos-seccion-${i}`}>
                <h2 className="font-serif text-2xl text-ink-deep">{s.titulo}</h2>
                {s.parrafos.map((p, j) => (
                  <p key={j} className="mt-4 leading-relaxed text-ink-text">
                    {p}
                  </p>
                ))}
              </section>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
